import React from "react";
import { useNavigate } from "react-router-dom"; // <- add this
import bg2 from "../assets/images/bg2.jpg";
import "./Hero.css";

const HeroSection = () => {
  const navigate = useNavigate(); // <- initialize navigate

  return (
    <section className="hero-section">
      <div className="container">
        <div className="row hero-row">

          {/* TEXT */}
          <div className="col-md-6 hero-text">
            <h2>A Smarter Way to Keep Your City Clean</h2>
            <p>
              WasteWatch is a modern platform designed to make urban cleanliness
              simpler and more efficient. It empowers communities to take part
              in creating healthier and greener cities.
            </p>

            {/* Button navigates to AddComplaint component */}
            <button
              className="hero-btn"
              onClick={() => navigate("/report-complaint")}
            >
              Report Complaint
            </button>

          </div>

          {/* IMAGE */}
          <div className="col-md-6 hero-image">
            <img src={bg2} alt="Waste Management" />
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
